export default __webpack_public_path__ + "static/media/his1.fc119f05.jpg";